import moment from "moment";
import { getAuthHeaders, getAuthHeadersForFormData } from "../auth";
import {
  CREATE_PROJECT_URL,
  FETCH_PROJECTS_LIST,
  FETCH_PROJECT_DETAILS,
  UPDATE_PROJECT_URL,
  FETCH_PROJECT_TASKS,
  FETCH_RESOURCE_PROJECTS,
  SAVE_PROJECT_TASKS,
  DELETE_PROJECT_TASKS,
  DELETE_PROJECT_ATTACHMENT,
  DELETE_PROJECT_ENGAGEMENT,
} from "../constants";
import { getQueryParams } from "../../helpers";
const getPayloadValuesFromForm = (formValues) => {
  const {
    resourceId,
    projectId,
    managerId,
    empType,
    status,
    projectName,
    contractualPath,
    clientName,
    clientAddress,
    clientManagerName,
    clientMangerTitle,
    clientManagerEmail,
    clientManagerPhone,
    vendorName,
    vendorAddress,
    timesheetTo,
    invoiceTo,
    msaSignatoryTitle,
    msaSignatoryName,
    msaSignatoryEmail,
    msaSignatoryPhone,
    recruiterName,
    recruiterEmail,
    recruiterPhone,
    recruiterTitle,
    accountingContactName,
    accountingContactEmail,
    accountingContactPhone,
    accountingContactTitle,
    escalationContactName,
    escalationContactEmail,
    escalationContactPhone,
    escalationContactTitle,
    poStartDate,
    poEndDate,
    paymentTerms,
    billRate,
    invoiceFrequency,
    poMsa,
    po_wo_sow_,
    vendorLetter,
    coi,
    otherAttachments,
  } = formValues;

  const payload = {
    ResourceID: resourceId,
    ProjectName: projectName,
    ProjectID: projectId,
    EmploymentType: empType,
    ContractualPath: contractualPath,
    ManagerID: managerId,
    Status: status,
    ClientName: clientName,
    ClientAddress: clientAddress,
    ClientManagerName: clientManagerName,
    ClientManagerEmail: clientManagerEmail,
    ClientManagerPhone: clientManagerPhone,
    ClientManagerTitle: clientMangerTitle,
    VendorName: vendorName,
    VendorAddress: vendorAddress,
    TimesheetTo: timesheetTo,
    InvoiceToEmail: invoiceTo,
    MSASignatoryName: msaSignatoryName,
    MSASignatoryEmail: msaSignatoryEmail,
    MSASignatoryPhone: msaSignatoryPhone,
    MSASignatoryTitle: msaSignatoryTitle,
    RecruiterTitle: recruiterTitle,
    RecruiterName: recruiterName,
    RecruiterEmail: recruiterEmail,
    RecruiterPhone: recruiterPhone,
    AccountingContactTitle: accountingContactTitle,
    AccountingContactName: accountingContactName,
    AccountingContactEmail: accountingContactEmail,
    AccountingContactPhone: accountingContactPhone,
    EscalationContactTitle: escalationContactTitle,
    EscalationContactName: escalationContactName,
    EscalationContactEmail: escalationContactEmail,
    EscalationContactPhone: escalationContactPhone,
    POStartDate:
      poStartDate && moment(poStartDate, true).isValid()
        ? moment(poStartDate).format("YYYY-MM-DD")
        : null,
    POEndDate:
      poEndDate && moment(poEndDate, true).isValid()
        ? moment(poEndDate).format("YYYY-MM-DD")
        : null,
    PaymentTerms: paymentTerms,
    BillRate: billRate,
    InvoiceFrequency: invoiceFrequency,
    POMSA: poMsa,
    PO_WO_SOW: po_wo_sow_,
    VendorLetter: vendorLetter,
    COI: coi,
    OtherAttachments: otherAttachments,
  };
  return payload;
};
export const getCreateProjectServiceConfig = (formValues) => {
  const url = CREATE_PROJECT_URL;
  const payload = getPayloadValuesFromForm(formValues);
  const createPrjPayload = { ...payload, ProjectID: null };
  const { OtherAttachments } = createPrjPayload;
  const formData = new FormData();
  for (let key in createPrjPayload) {
    formData.append(key, createPrjPayload[key]);
  }
  formData.delete("OtherAttachments");
  formData.delete("ProjectID");
  if (Array.isArray(OtherAttachments) && OtherAttachments.length) {
    OtherAttachments.forEach((attachment) => {
      formData.append("OtherAttachments", attachment);
    });
  } else {
    formData.append("OtherAttachments", null);
  }
  return {
    url,
    options: {
      method: "POST",
      headers: getAuthHeadersForFormData(),
      body: formData,
    },
  };
};

export const updateProjectServiceConfig = (formValues) => {
  const updatePayload = getPayloadValuesFromForm(formValues);
  const { OtherAttachments } = updatePayload;
  const formData = new FormData();
  for (let key in updatePayload) {
    formData.append(key, updatePayload[key]);
  }
  formData.delete("OtherAttachments");
  if (Array.isArray(OtherAttachments) && OtherAttachments.length) {
    OtherAttachments.forEach((attachment) => {
      formData.append("OtherAttachments", attachment);
    });
  } else {
    formData.append("OtherAttachments", null);
  }
  return {
    url: UPDATE_PROJECT_URL,
    options: {
      method: "PUT",
      headers: getAuthHeadersForFormData(),
      body: formData,
    },
  };
};
export const getProjectsListServiceConfig = (queryString) => {
  return {
    url: `${FETCH_PROJECTS_LIST}?${queryString}`,
    options: {
      method: "GET",
      headers: getAuthHeaders(),
    },
  };
};

export const getProjectDetailsServiceConfig = (projectId) => {
  return {
    url: `${FETCH_PROJECT_DETAILS}?ProjectID=${projectId}`,
    options: {
      method: "GET",
      headers: getAuthHeaders(),
    },
  };
};

export const saveProjectTaskServiceConfig = (formValues) => {
  const { taskId, taskName, isActive } = formValues;
  const payload = {
    ProjectTaskID: taskId || null,
    ProjectTaskName: taskName,
    IsActive: isActive,
  };
  return {
    url: SAVE_PROJECT_TASKS,
    options: {
      method: "POST",
      body: JSON.stringify(payload),
      headers: getAuthHeaders(),
    },
  };
};
export const deleteProjectTaskServiceConfig = (taskId) => {
  return {
    url: `${DELETE_PROJECT_TASKS}?ProjectTaskID=${taskId}`,
    options: {
      method: "DELETE",
      headers: getAuthHeaders(),
    },
  };
};
export const getProjectTaskServiceConfig = () => {
  return {
    url: FETCH_PROJECT_TASKS,
    options: {
      method: "GET",
      headers: getAuthHeaders(),
    },
  };
};

export const getResourceProjectListSerivceConfig = () => {
  return {
    url: `${FETCH_RESOURCE_PROJECTS}`,
    options: {
      method: "GET",
      headers: getAuthHeaders(),
    },
  };
};

export const deleteProjectAttachment = (
  projectId,
  fieldName,
  attachmentName
) => {
  const payload = {
    ProjectID: projectId,
    FileName: attachmentName,
    Field: fieldName,
  };
  const queryParams = getQueryParams(payload);
  return {
    url: `${DELETE_PROJECT_ATTACHMENT}?${queryParams}`,
    options: {
      method: "DELETE",
      headers: getAuthHeaders(),
    },
  };
};

export const deleteProjectEngagementReqConfig = (projectIds) => {
  return {
    url: `${DELETE_PROJECT_ENGAGEMENT}?ProjectIDs=${projectIds.join(",")}`,
    options: {
      method: "DELETE",
      headers: getAuthHeaders(),
    },
  };
};

// export const GetReportsList = (projectIds) => {
//   return {
//     url: `${FETCH_REPORTS_LIST}?StartDates=${projectIds.join(",")}`,
//     options: {
//       method: "GET",
//       headers: getAuthHeaders(),
//     },
//   };
// };
